// Copyright (c) 2019 Comsearch, Inc., All rights reserved

export const UPDATE_PATH_VALIDATIONS_DRAWER = 'UPDATE_PATH_VALIDATIONS_DRAWER'
